import axios from '@/utils/ajax/index'; // 倒入 api


export const login = (data) => {
  return axios({
    url: '/login/login',
    method: 'post',
    data,
  });
};

export const signOut = (data) => {
  return axios({
    url: '/login/logout',
    method: 'post',
    data,
  });
}

export const treeList = (data) => {
  return axios({
    url: '/hospitalManage/permission/menus',
    method: 'get',
    data,
  });
};
// 消息列表
export const messageList = (data) => {
  return axios({
    url: '/system/message/pageMessages',
    method: 'post',
    data,
    hideLoading: true,
  });
};

// 消息批量已读
export const messageBatchUpdate = (data) => {
  return axios({
    url: '/system/message/batchRead',
    method: 'post',
    data,
  });
};

// 消息批量删除
export const messageBatchDelete = (data) => {
  return axios({
    url: '/system/message/batchDelete',
    method: 'post',
    data,
  });
};

// 查询消息详情
export const getMessage = (params) => {
  return axios({
    url: `/system/message/${params.id}`,
    method: 'GET',
    params,
    hideLoading: true,
  });
};

// 商城单点登录
export const loginShopping = (data) => {
  return axios({
    url: '/shopOnline/isAllowLogin',
    method: 'POST',
    data,
  });
};

// 商城单点登录
export const registHospitalForTrial = (data) => {
  return axios({
    url: '/registHospitalForTrial',
    method: 'POST',
    data,
  });
};

// 修改密码
export const updatePassword = (data) => {
  return axios({
    url: '/hospitalManage/user/updatePassword',
    method: 'POST',
    data,
  });
};

// 防串号
export const checkToken = (data) => {
  return axios({
    url: '/login/checkToken',
    method: 'POST',
    data,
  });
};

// 查询最新系统消息
export const getRecentMessage = (params) => {
  return axios({
    url: '/system/message/getRecentMessage',
    method: 'GET',
    params,
  });
};

export default {
  login,
  treeList,
  signOut,
  messageList,
  messageBatchUpdate,
  messageBatchDelete,
  getMessage,
  loginShopping,
  registHospitalForTrial,
  updatePassword,
  checkToken,
  getRecentMessage,
};
